<template>
  <div class="box dependente'">
    <div class="form-control">
      <label :for="`cf_dependente_nome_completo_${idData}`"
        >Nome completo</label
      >
      <input
        :id="'cf_dependente_nome_completo_' + idData"
        name="cf_dependente_nome_completo"
      />
    </div>

    <div class="form-control">
      <label :for="`cf_dependente_data_nascimento_${idData}`"
        >Data Nascimento</label
      >
      <input
        :id="'cf_dependente_data_nascimento_' + idData" 
        name="cf_dependente_data_nascimento"
        type="date"
        @blur="validateDataNascimento(idData)"
        @change="validateDataNascimento(idData)"
      />
      <span v-if="error_datas_nascimento[idData]" class="error-message">
        Data inválida.
      </span>
    </div>

    <div class="form-control">
      <label :for="`cf_dependente_parentesco_${idData}`">Parentesco</label>
      <select
        :id="'cf_dependente_parentesco_' + idData"
        name="cf_dependente_parentesco"
        required="true"
        v-model="parentesco"
      >
        <option value=""></option>
        <option value="C">Cônjuge</option>
        <option value="F">Filho(a)</option>
        <option value="E">Enteado(a)</option>
        <option value="P">Pai ou Mãe</option>
        <option value="O">Outros</option>
      </select>
    </div>
    <div class="form-control">
      <label :for="`cf_dependente_sexo_${idData}`">Sexo</label>
      <select
        :id="'cf_dependente_sexo_' + idData"
        name="cf_dependente_sexo"
        required="true"
      >
        <option value=""></option>
        <option value="F">Feminino</option>
        <option value="M">Masculino</option>
      </select>
    </div>

    <div class="form-control">
      <label :for="`cf_dependente_cpf_${idData}`">CPF</label>
      <input
        :id="`cf_dependente_cpf_${idData}`"
        name="cf_dependente_cpf"
        v-mask="'###.###.###-##'"
        v-model="dependente_cpfs[idData]"
        @blur="validateCpf(idData)"
        @keyup="validateCpf(idData)"
        @keydown="validateCpf(idData)"
        :ref="`cpfInput_${idData}`"
      />
      <span v-if="error_cpfs[idData]" class="error-message">
        CPF inválido. Exemplo: 123.456.789-09
      </span>
    </div>

    <div class="form-control">
      <label :for="`cf_dependente_ir_${idData}`">Dependente IR?</label>
      <select
        :id="'cf_dependente_ir_' + idData"
        name="cf_dependente_ir"
        required="true"
      >
        <option value="sim">Sim</option>
        <option value="nao" selected>Não</option>
      </select>
    </div>

       <h3 style="display: inline; margin-right: 10px;">Anexos</h3>
    <h5 style="display: inline;">Tam. máx. 5mb.</h5>
    <span v-if="!isAnexoRequired('cf_dependente_anexo_rg') && 
        !isAnexoRequired('cf_dependente_anexo_cpf') &&
        !isAnexoRequired('cf_dependente_anexo_certidao_nascimento')">
      Os anexos obrigatórios já foram enviados ou não são necessários.
    </span>
    <div class="form-control" v-if="isAnexoRequired('cf_dependente_anexo_rg')">
      <label :for="`cf_dependente_anexo_rg_${idData}`">Foto RG:</label>
      <input
        type="file"
        :id="`cf_dependente_anexo_rg_${idData}`"
        :name="`cf_dependente_anexo_rg_${idData}`"
        accept="image/*,application/pdf"
        :ref="`cf_dependente_anexo_rg_${idData}`"
        multiple
        required="true"
      />
      <p
        v-if="findAnexoDependente('cf_dependente_anexo_rg').resposta_sworks"
        class="error-message"
      >
        Erro:
        {{ findAnexoDependente("cf_dependente_anexo_rg").resposta_sworks }}
      </p>
    </div>

    <div class="form-control" v-if="isAnexoRequired('cf_dependente_anexo_cpf')">
      <label :for="`cf_dependente_anexo_cpf_${idData}`">Foto CPF:</label>
      <input
        type="file"
        :id="`cf_dependente_anexo_cpf_${idData}`"
        :name="`cf_dependente_anexo_cpf_${idData}`"
        accept="image/*,application/pdf"
        :ref="`cf_dependente_anexo_cpf_${idData}`"
        multiple
        required="true"
      />
      <p
        v-if="findAnexoDependente('cf_dependente_anexo_cpf').resposta_sworks"
        class="error-message"
      >
        Erro:
        {{ findAnexoDependente("cf_dependente_anexo_cpf").resposta_sworks }}
      </p>
    </div>

    <div
      class="form-control"
      v-if="isAnexoRequired('cf_dependente_anexo_certidao_nascimento')"
    >
  <label :for="`cf_dependente_anexo_certidao_nascimento_${idData}`">
  {{ labelCertidao }}
  </label>


      <input
        type="file"
        :id="`cf_dependente_anexo_certidao_nascimento_${idData}`"
        :name="`cf_dependente_anexo_certidao_nascimento_${idData}`"
        accept="image/*,application/pdf"
        :ref="`cf_dependente_anexo_certidao_nascimento_${idData}`"
        multiple
        required="true"
      />
      <p
        v-if="
          findAnexoDependente('cf_dependente_anexo_certidao_nascimento')
            .resposta_sworks
        "
        class="error-message"
      >
        Erro:
        {{
          findAnexoDependente("cf_dependente_anexo_certidao_nascimento")
            .resposta_sworks
        }}
      </p>
    </div>
  </div>
</template>
<script>
import { mask } from "vue-the-mask";

export default {

computed: {
  labelCertidao() {
    if (this.parentesco === 'C') {
      if (this.estadoCivil === 'casado') {
        return 'Foto Certidão de Casamento:';
      }
      if (this.estadoCivil === 'uniao_estavel') {
        return 'Foto Declaração de União Estável:';
      }
    }
    return 'Foto Certidão de Nascimento:';
  }
},

  
  props: {
    idData: Number,
    dependente: Object,
    dadosDependentes: Array,
     estadoCivil: String,
  },
  data: () => ({
    parentesco: "",
    dependente_cpfs: {}, // Armazena os valores dos CPFs por ID
    error_cpfs: {}, // Armazena os erros de CPF por ID
    error_datas_nascimento: {},
  }),
  directives: { mask },
  methods: {
    // Encontra o anexo pendente com base no nome do campo
    findAnexoDependente(nomeCampo) {
      if (
        !this.dadosDependentes.length ||
        !this.dadosDependentes[this.idData]
      ) {
        return {};
      }
      return (
        this.dadosDependentes[this.idData].anexos.find(
          (anexo) => anexo.nome_campo_form === nomeCampo
        ) || {}
      );
    },
    // verifica se campo anexo precisa ser exibido
    // se tiver com erro ou se nao existir no banco, tem que exibir
    isAnexoRequired(nomeCampo) {
      const anexo = this.findAnexoDependente(nomeCampo);
      // não existe anexo salvo no banco de dados
      if (Object.keys(anexo).length === 0) {
        return true;
      } else {
        // existe anexo no banco de dados e está com erro
        if (anexo?.resposta_sworks) {
          return true;
          // existe anexo no banco, mas não tem erro
        } else {
          return false;
        }
      }
    },
    validateCpf(id) {
      const rawCpf = (this.dependente_cpfs[id] || "").replace(/\D/g, "");

      if (!rawCpf) {
        this.$set(this.error_cpfs, id, false);
        return;
      }

      // CPF inválido se for diferente de 11 ou todos dígitos iguais
      if (rawCpf.length !== 11 || /^(\d)\1+$/.test(rawCpf)) {
        this.$set(this.error_cpfs, id, true);
        return;
      }

      let sum = 0;
      for (let i = 0; i < 9; i++) sum += +rawCpf[i] * (10 - i);
      let firstDigit = (sum * 10) % 11;
      if (firstDigit === 10) firstDigit = 0;
      if (firstDigit !== +rawCpf[9]) {
        this.$set(this.error_cpfs, id, true);
        return;
      }

      sum = 0;
      for (let i = 0; i < 10; i++) sum += +rawCpf[i] * (11 - i);
      let secondDigit = (sum * 10) % 11;
      if (secondDigit === 10) secondDigit = 0;
      if (secondDigit !== +rawCpf[10]) {
        this.$set(this.error_cpfs, id, true);
        return;
      }

      // CPF válido
      this.$set(this.error_cpfs, id, false);
    },
    validateDataNascimento(id) {
      const inputId = `cf_dependente_data_nascimento_${id}`;
      const input = document.getElementById(inputId);
      if (!input) return;

      const valor = input.value;
      const data = new Date(valor);
      const hoje = new Date();

      if (
        !valor || // vazio
        isNaN(data.getTime()) || // inválida
        data > hoje || // futura
        data.getFullYear() < 1900 // muito antiga
      ) {
        this.$set(this.error_datas_nascimento, id, true);
      } else {
        this.$set(this.error_datas_nascimento, id, false);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  border: 1px solid #c1c7d0;
  padding: 10px;
  border-radius: 5px;
  margin: 10px 0;
}
.error-message {
  color: red;
  margin-top: 10px;
  border-bottom: 2px solid red;
}
</style>
